import { StoreSetter } from './types';

interface RunApiActionOptions<TStore, TResult> {
  set: StoreSetter<TStore>;
  loadingKey?: keyof TStore & string;
  action: () => Promise<TResult>;
  onSuccess?: (result: TResult) => void;
  onError?: (error: unknown) => void;
  setLoading?: boolean;
  clearLoadingOnFinish?: boolean;
}

export async function runApiAction<TStore, TResult>({
  set,
  loadingKey = 'isLoading' as keyof TStore & string,
  action,
  onSuccess,
  onError,
  setLoading = false,
  clearLoadingOnFinish = false,
}: RunApiActionOptions<TStore, TResult>): Promise<TResult | undefined> {
  if (setLoading) {
    set({ [loadingKey]: true } as Partial<TStore>);
  }

  try {
    const result = await action();
    onSuccess?.(result);
    return result;
  } catch (error) {
    onError?.(error);
    console.log({ error });
    return undefined;
  } finally {
    if (clearLoadingOnFinish) {
      set({ [loadingKey]: false } as Partial<TStore>);
    }
  }
}
